import zhCN from "antd/es/locale/zh_CN";
import enUS from "antd/es/locale/en_US";

export const appLocales = {
  "zh-CN": require("../locales/zh_CN.json"),
  "en-US": require("../locales/en_US.json"),
};

export const antdLocales = {
  "zh-CN": zhCN,
  "en-US": enUS,
};
